<template>
<div :style="width?{width}:{}">
  <input :style="width?{width}:{}" type="text" v-model="value" name="searchText" :placeholder="placeholder?placeholder:'搜尋'" @change="$emit('search', value)" @keypress.enter="$emit('search', value)">
</div>
</template>

<script>
export default {
  props: ['defaultValue', 'placeholder', 'width'],
  data () {
    return {
      value: null
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  watch: {
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  position: relative;
  height: 40px;
  align-items: center;
  justify-content: flex-start;
  display: inline-flex;
  margin-block: auto;
  &::after {
    content: '';
    background-color: var(--color-pri);
    mask-image: url(./svg/btn/search.svg);
    display: inline-block;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 11px;
    top: 10px;
  }
}
input[type=text] {
  border-radius: 3px;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  height: 40px;
  padding-inline: 1em;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  &::placeholder {
    color: #CACACA;
  }
}
</style>
